import type { MetricsOverviewDto, TimeseriesDto } from '@planuze/admin-contracts';
import { MetricCardsGrid } from '../metric-cards-grid.js';
import { MetricsFilters, type MetricsFiltersValue } from '../metrics-filters.js';
import { SignupsTimeseriesChart } from '../signups-timeseries-chart.js';

interface Props {
  readonly overview: MetricsOverviewDto | undefined;
  readonly filters: MetricsFiltersValue;
  readonly onFiltersChange: (value: MetricsFiltersValue) => void;
  readonly data: TimeseriesDto | undefined;
  readonly loading: boolean;
}

/* Aba Cadastros: cards de signups + o filtro de período/granularidade (escopado aqui,
   pois é a única superfície que consome from/to/grain) + a série temporal de signups. */
export function SignupsTab({ overview, filters, onFiltersChange, data, loading }: Props) {
  return (
    <div className="space-y-4">
      <MetricCardsGrid overview={overview} section="signups" />
      <MetricsFilters value={filters} onChange={onFiltersChange} />
      <SignupsTimeseriesChart data={data} loading={loading} />
    </div>
  );
}
